<template>
  <div class="investments">
    <PortfolioStats :portfolio="current_portfolio.data"/>
    <PortfolioDynamics/>
    <PortfolioStructure v-if="!grouped_assets_list.dirty" :portfolio-assets="grouped_assets_list.data"/>
  </div>
</template>

<script>
import {mapState} from "vuex";
import BaseButton from "@/components/UI/BaseButton";
import PortfolioStats from "@/components/cabinet/Investments/Dashboard/PortfolioStats/PortfolioStats";
import PortfolioStructure from "@/components/cabinet/Investments/Dashboard/PortfolioStructure/PortfolioStructure";
import PortfolioDynamics from "@/components/cabinet/Investments/Dashboard/PortfolioDynamics/PortfolioDynamics";

export default {
  name: "TheInvestmentsDashboard",
  components: {
    PortfolioDynamics,
    PortfolioStructure,
    PortfolioStats,
    BaseButton,
  },
  computed: {
    ...mapState('investments/portfolios', ['portfolios_list', 'current_portfolio']),
    ...mapState('investments/assets', ['grouped_assets_list']),
    ...mapState('space', ['current_space'])
  }
}
</script>